import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import MerchantDetails from '@/components/v2/network_distributor/MerchantDetails.vue';
import DisplayBillingMenu from '@/plugins/graphql/mutations/v2/network_distributor/display-billing-menu.gql';
import DisplayBillingWidget from '@/plugins/graphql/mutations/v2/network_distributor/display-billing-widget.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
let MerchantSettings = class MerchantSettings extends Mixins(AlertMixin) {
    constructor() {
        super(...arguments);
        this.allowBillingMenu = false;
        this.mutationOnFlight = false;
    }
    get merchantUuid() {
        return this.$route.params.merchantUuid;
    }
    async displayBillingMenu(display, appUuid) {
        await this.$apollo
            .mutate({
            mutation: DisplayBillingMenu,
            variables: {
                input: {
                    display,
                    appUuid,
                },
            },
        })
            .then(() => {
            const msg = `${display ? 'Display' : 'Hide'} Billing Menu`;
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
    async displayBillingWidget(display, appUuid) {
        await this.$apollo
            .mutate({
            mutation: DisplayBillingWidget,
            variables: {
                input: {
                    display,
                    appUuid,
                },
            },
        })
            .then(() => {
            const msg = `${display ? 'Display' : 'Hide'} Billing Widget`;
            this.successNotification(msg);
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
};
MerchantSettings = __decorate([
    Component({
        components: {
            AppBasicDetails,
            MerchantDetails,
        },
    })
], MerchantSettings);
export default MerchantSettings;
